import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  Pagination,
  t
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class ServiceHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_asset: "All Assets",
      filter_type: "All Service Types",
      filter_date: "Last 12 months",

      count: 158,
      page: 1,

      // -----------------------------------
      // Mock Data: Service History (อิงตามรูป image_164b3e.jpg)
      // -----------------------------------
      data: [
        {
          id: "WO-20250120-001",
          title: "Compressor Motor Replacement",
          asset: "Chiller Unit #3",
          location: "Building A, Floor 1",
          date: "Jan 20, 2025",
          tech: "Somchai T.",
          duration: "2h 30m",
          type: "Emergency Repair",
          status: "Completed",
          statusColor: "success",
          rating: 5.0,
          resolution: "Replaced compressor motor with new unit. Checked refrigerant levels and topped up as needed. Cleared error codes and reset system. Tested operation for 30 minutes - running normally.",
          parts_used: 3,
          photos: 5
        },
        {
          id: "WO-20250115-002",
          title: "Quarterly PM Inspection",
          asset: "Generator #1",
          location: "Basement",
          date: "Jan 15, 2025",
          tech: "Prasert K.",
          duration: "3h 45m",
          type: "Preventive Maintenance",
          status: "Completed",
          statusColor: "success",
          rating: 4.0,
          resolution: "Completed quarterly preventive maintenance checklist. Oil change performed. Filters replaced. All safety systems tested and operational. Recommended battery replacement within next 3 months.",
          parts_used: 2,
          photos: 8,
          recommendation: 1
        },
        {
          id: "WO-20250110-003",
          title: "Filter Replacement & Cleaning",
          asset: "AHU Floor 5",
          location: "Building B, Rooftop",
          date: "Jan 10, 2025",
          tech: "Wichai S.",
          duration: "1h 15m",
          type: "Preventive Maintenance",
          status: "Completed",
          statusColor: "success",
          rating: 5.0,
          resolution: "Replaced all air filters (4 units). Cleaned coils and drain pan. Checked belt tension and lubricated bearings. System running efficiently with improved airflow.",
          parts_used: 4,
          photos: 6
        },
        {
          id: "WO-20250105-001",
          title: "Pressure Gauge Calibration",
          asset: "Boiler System",
          location: "Building A, Utility Room",
          date: "Jan 05, 2025",
          tech: "Somchai T.",
          duration: "2h 00m",
          type: "Inspection",
          status: "Follow-up Required",
          statusColor: "warning",
          rating: 4.0,
          resolution: "Calibrated pressure gauges. Found secondary relief valve needs replacement - part ordered. Follow-up visit scheduled for Jan 30, 2025.",
          follow_up_info: "Follow-up scheduled: Jan 30, 2025 - Relief valve replacement",
          parts_used: 0,
          photos: 3,
          parts_on_order: true
        }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  Get = async (page) => {
    // API logic to fetch history
  }

  render() {
    const { data, count, filter_search, filter_asset, filter_type, filter_date } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("service_history")}</h3>
            <div className="text-secondary text-14">{t("history_desc")}</div>
          </div>

          {/* KPI Summary (Top Stats) */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("total_services")}</div>
                    <h3 className="fw-bold mb-0 mt-1">{count}</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">{"\uf15b"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("completed")}</div>
                    <h3 className="fw-bold text-success mb-0 mt-1">152</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf058"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("follow_up")}</div>
                    <h3 className="fw-bold text-warning mb-0 mt-1">4</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-18 icon">{"\uf2f1"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("avg_rating")}</div>
                    <h3 className="fw-bold text-purple mb-0 mt-1">4.8</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center text-18 icon">{"\uf005"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Bar */}
          <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-center gap-3">
            <div className="position-relative flex-grow-1" style={{ maxWidth: "550px" }}>
              <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
              <input type="text" className="form-control ps-5 rounded-3 border-light bg-light" placeholder={t("search_history")} />
            </div>
            <select className="form-select wpx-150 rounded-3 border-light fw-bold text-secondary text-13 shadow-none">
              <option>{t("all_assets")}</option>
            </select>
            <select className="form-select wpx-180 rounded-3 border-light fw-bold text-secondary text-13 shadow-none">
              <option>{t("all_service_types")}</option>
            </select>
            <select className="form-select wpx-150 rounded-3 border-light fw-bold text-secondary text-13 shadow-none">
              <option>{t("last_12_months")}</option>
            </select>
            <button className="btn btn-primary px-3 fw-bold d-flex align-items-center rounded-3 shadow-sm border-0">
              <span className="icon me-2">{"\uf019"}</span> {t("export")}
            </button>
          </div>

          {/* History List */}
          <div className="d-flex flex-column gap-4">
            {data.map((item, idx) => (
              <div key={idx} className={`card border-0 rounded-4 shadow-sm bg-white overflow-hidden ${item.statusColor === 'warning' ? 'border-start border-5 border-warning' : ''}`}>
                <div className="p-4">
                  {/* Card Header */}
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="d-flex">
                      <div className={`wpx-35 hpx-35 rounded-circle d-flex align-items-center justify-content-center me-3 text-white ${item.statusColor === 'success' ? 'bg-success' : 'bg-warning'}`}>
                        <span className="icon text-12">{item.statusColor === 'success' ? "\uf00c" : "\uf2f1"}</span>
                      </div>
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <h5 className="fw-bold text-dark mb-0">{item.title}</h5>
                          <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-1 text-8 fw-bold`}>{item.status}</span>
                        </div>
                        <div className="text-secondary text-13">{item.asset} • {item.location}</div>
                      </div>
                    </div>
                    <div className="text-end">
                      <div className="text-secondary text-10 font-monospace mb-1">{item.id}</div>
                      <div className="text-warning text-14">
                        {[...Array(5)].map((_, i) => (
                          <span key={i} className="icon">{i < Math.floor(item.rating) ? "\uf005" : "\uf006"}</span>
                        ))}
                        <span className="text-secondary text-12 ms-1 fw-bold">{item.rating.toFixed(1)}</span>
                      </div>
                    </div>
                  </div>

                  {/* Info Icons Bar */}
                  <div className="d-flex align-items-center gap-4 mb-3 text-secondary text-12">
                    <span><span className="icon me-1">{"\uf073"}</span> {item.date}</span>
                    <span><span className="icon me-1">{"\uf007"}</span> {item.tech}</span>
                    <span><span className="icon me-1">{"\uf017"}</span> {item.duration}</span>
                    <span><span className="icon me-1">{"\uf0ad"}</span> {item.type}</span>
                  </div>

                  {/* Resolution Text */}
                  <div className="bg-light bg-opacity-50 p-3 rounded-3 mb-3">
                    <div className="text-dark fw-bold text-12 mb-1">{t("resolution")}:</div>
                    <div className="text-secondary text-13 lh-base">{item.resolution}</div>
                    {item.follow_up_info && (
                      <div className="mt-2 text-danger fw-bold text-12 d-flex align-items-center">
                        <span className="icon me-1">{"\uf071"}</span> {item.follow_up_info}
                      </div>
                    )}
                  </div>

                  {/* Badges and Actions */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex gap-2">
                      <span className="badge bg-primary-light text-primary rounded-1 text-10 fw-normal px-2 py-1">{item.parts_used} {t("parts_used")}</span>
                      <span className="badge bg-purple-light text-purple rounded-1 text-10 fw-normal px-2 py-1">{item.photos} {t("photos")}</span>
                      {item.recommendation && <span className="badge bg-warning-light text-warning rounded-1 text-10 fw-normal px-2 py-1">{item.recommendation} {t("recommendation")}</span>}
                      {item.parts_on_order && <span className="badge bg-danger-light text-danger rounded-1 text-10 fw-normal px-2 py-1">{t("parts_on_order")}</span>}
                    </div>
                    <div className="d-flex gap-3">
                      <button className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-13"><span className="icon me-1">{"\uf06e"}</span> {t("view_details")}</button>
                      <button className="btn btn-link text-success text-decoration-none fw-bold p-0 text-13"><span className="icon me-1">{"\uf019"}</span> {t("download_report")}</button>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12 mt-4">
            <div>{t("showing")} 1-{data.length} {t("of")} {count} {t("service_records")}</div>
            <Pagination count={Math.ceil(count / 10)} onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
      </div>
    );
  }
}